import React from 'react';
import ShopApiSettingsForm from '../components/ShopApiSettingsForm';

const ShopListPage: React.FC = () => <ShopApiSettingsForm />;

export default ShopListPage;
